import React from 'react';
import {
  Modal,
  Paper,
  List,
  IconButton,
  Typography,
  Box,
  SxProps,
  Skeleton,
  useTheme
} from '@mui/material';
import { Button } from 'system/atoms';
import CloseIcon from '@mui/icons-material/Close';
import { AttachmentItem } from 'services/conversations/components/AttachmentItem';
import { useConversationAttachments } from 'services/conversations/hooks';

type Props = {
  open: boolean;
  handleClose: () => void;
  conversationId: string;
  recipientName: string;
};

const container: SxProps = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  padding: 2,
  minWidth: 300,
  maxWidth: '80%',
  maxHeight: '80%',
  overflowY: 'auto'
};

const AttachmentsModal: React.FC<Props> = ({
  open,
  handleClose,
  conversationId,
  recipientName
}) => {
  const {
    palette: { primary }
  } = useTheme();

  const {
    attachments,
    downloadAllFiles,
    downloadFile,
    isDownloading,
    isLoading
  } = useConversationAttachments(conversationId, {
    recipientName
  });

  return (
    <Modal open={open} onClose={handleClose}>
      <Paper sx={container}>
        <IconButton
          onClick={handleClose}
          style={{ position: 'absolute', right: 10, top: 10 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" style={{ fontWeight: '400' }}>
          Candidate documents
        </Typography>
        <Typography variant="subtitle1" fontWeight={500} mb={2}>
          From{' '}
          <span
            style={{
              color: primary.main
            }}
          >
            {recipientName}
          </span>
        </Typography>
        {isLoading ? (
          <Skeleton variant="rectangular" height={400} width={400} />
        ) : (
          <List>
            {attachments.map((attachment) => (
              <AttachmentItem
                key={attachment.id}
                attachment={attachment}
                downloadFile={downloadFile}
              />
            ))}
          </List>
        )}
        <Box textAlign="center" marginTop={2}>
          <Button
            variant="primary"
            onClick={downloadAllFiles}
            disabled={isDownloading || attachments.length === 0}
            loading={isDownloading}
            fullWidth
          >
            Download All
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};

export { AttachmentsModal };
